import { useAuthStore } from '@/stores/auth'

const allMenu = [
  {
    text: "Home",
    path: "/home",
    icon: "home"
  },
  {
    text: "HAProxy",
    icon: "globe",
    items: [
      { text: 'Validation', path: '/haproxy-config-validate' },
      { text: 'Configuration', path: '/haproxy-config' },
      { text: "SSL Certs", path: "/haproxy-certs" }
    ]
  },
  {
    text: "Nginx",
    icon: "box",
    items: [
      { text: 'Sites', path: '/nginx-sites' }
    ]
  },
  {
    text: "Docker",
    icon: "product",
    items: [
      { text: "All Containers", path: "/docker-all-containers" },
      { text: "Stats", path: "/docker-stats" },
      { text: "Networks", path: "/docker-networks" },
      { text: "Cont. + Net", path: "/docker-containers-with-networks" },
      { text: "Net + Cont.", path: "/docker-networks-with-containers" }
    ]
  },
  {
    text: "WordPress",
    icon: "ordersbox",
    items: [
      { text: "Site Snapshots", path: "/wordpress-site-snapshots" }
    ]
  },
  {
    text: "Cloudflare",
    icon: "link",
    role: "admin", // ✅ Only admins can see this whole section
    items: [
      { text: "DNS Records", path: "/cloudflare-dns-records" },
      { text: "DNS Zones", path: "/cloudflare-dns-zones" },
      { text: "All Records", path: "/cloudflare-dns-records-all" }
    ]
  },
  {
    text: "Examples",
    icon: "folder",
    items: [
      { text: "Profile", path: "/profile4" },
      { text: "Tasks", path: "/tasks4" },
      { text: 'Node Agents', path: '/node-agents4' }
    ]
  }
]

export default function getFilteredMenu() {
  const store = useAuthStore()
  const userRole = store.user?.role

  // Recursively filter top-level items and sub-items
  const filterByRole = (item) => {
    if (item.role && item.role !== userRole) return false
    if (item.items) {
      item.items = item.items.filter(filterByRole)
      return item.items.length > 0 || !item.role
    }
    return true
  }

  return allMenu.filter(filterByRole)
}
